import { Pagination } from '@lawpilots/design-system'
import { useTranslation } from 'react-i18next'

const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100]

export type ListPaginationProps = {
  /** 1-based, as the design-system control counts. */
  page: number
  pageCount: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: number) => void
  pageSizeOptions?: number[]
}

/**
 * The footer every paged table shares: the design-system control plus the
 * localised strings it is i18n-agnostic about.
 *
 * A table renders it even on a single page or an empty result. An illustrated
 * empty state replaces the table and its pager.
 */
export const ListPagination = ({
  page,
  pageCount,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}: ListPaginationProps): JSX.Element => {
  const { t } = useTranslation('general')

  return (
    <Pagination
      page={page}
      // A count of 0 would leave the control with no page button at all.
      pageCount={Math.max(1, pageCount)}
      onPageChange={onPageChange}
      pageSize={pageSize}
      pageSizeOptions={pageSizeOptions}
      onPageSizeChange={onPageSizeChange}
      labels={{
        rowsPerPage: t('rowsPerPage'),
        previous: t('previous'),
        next: t('next'),
        pageLabel: (value) => t('pagination_page_label', { page: value }),
        navLabel: t('pagination_nav_label'),
      }}
    />
  )
}
